// extracted by mini-css-extract-plugin
export var displayNone = "_o1-6";
export var imgContainer = "_o1-2";
export var overflowHidden = "_o1-3";
export var productInfoCardButtonContainer = "_o1-5";
export var productTitleText = "_o1-4";
export var rightArrow = "_o1-1";
export var rightArrowContainer = "_o1-0";